import { createRoot } from "react-dom/client";
import { ProjectList } from "./scripts/ProjectList.js";

const projects = [
  {
    id: "mern-blog",
    name: "MERN Blog",
    img: "/assets/images/projects/mern-blog.png",
    imgSmall: "/assets/images/projects/mern-blog-small.webp",
    badge: "in progress",
    tech: ["React", "Node.js", "Express.js", "MongoDB", "REST API", "Authentication"],
    description: "A full-stack blogging platform built with React, Node.js, Express and MongoDB. Users can register, log in, reset their password, create and manage their own posts, and access protected areas of the application. The React frontend communicates with a REST API, with session-based authentication, cookies, CSRF protection and server-side authorization based on user ownership.",
    link: "https://the-blog-mern.netlify.app/",
    codeLink: "https://github.com/helen25sur/blog-frontend",
  },
  {
    id: "candeleaf-site",
    name: "Online Shop 'Candeleaf'",
    img: "/assets/images/projects/candeleaf-site.png",
    imgSmall: "/assets/images/projects/candeleaf-site-small.webp",
    badge: "in progress",
    tech: ["Node.js", "Express.js", "MySQL", "EJS", "REST API", "Authentication"],
    description: "A server-rendered e-commerce application for browsing products, viewing product details and managing a shopping cart. Users can register, log in, reset their password and create, edit or delete their own products. Built with Node.js and Express using EJS, MySQL and REST API endpoints, with authentication, authorization and email-based account verification and password reset.",
    link: "https://candleaf2.onrender.com/",
    codeLink: "https://github.com/helen25sur/online-shop-nodejs",
  },
  {
    id: "bookshelf-vue-app",
    name: "Bookshelf App",
    img: "/assets/images/projects/bookshelf-vue-app.png",
    imgSmall: "/assets/images/projects/bookshelf-vue-app-small.webp",
    tech: ["Vue.js", "Vuex", "Vue Router", "Tailwind CSS", "Firebase", "REST API"],
    description: "A Vue.js single-page application for discovering and organizing books. Users can search for books, browse New York Times bestseller lists, view detailed book information and save books to personal “Read” and “Want to Read” lists. The application integrates Google Books and NYT APIs with Firebase for authentication, user accounts, personal book lists and profile image storage, while the interface is built entirely with Tailwind CSS.",
    link: "https://bookshelf-vue.netlify.app/",
    codeLink: "https://github.com/helen25sur/Bookshelf-app",
  },
  {
    id: "task-manager-node",
    name: "Task Manager App",
    img: "/assets/images/projects/task-manager-node.png",
    imgSmall: "/assets/images/projects/task-manager-node-small.webp",
    tech: ["JavaScript (ES6+)", "Node.js", "Express.js", "REST API", "JSONBin.io"],
    description: "A task management application built with Node.js and Express. Users can create, edit and delete tasks, update their status between To Do, In Progress and Completed, and track creation and modification timestamps. Task data is stored remotely using JSONBin.io and managed through its REST API, with support for light and dark themes.",
    link: "https://todo-nodejs-hf6g.onrender.com/",
    codeLink: "https://github.com/helen25sur/todo-nodejs",
  },
  {
    id: "onua-site",
    name: "ONUA University Website",
    img: "/assets/images/projects/onua-site.png",
    imgSmall: "/assets/images/projects/onua-site-small.webp",
    tech: ["Joomla", "HTML5", "CSS3", "JavaScript (ES6+)", "Responsive Design"],
    description: "A professional university website I worked on from 2017 to 2022, initially focusing on CMS content management, maintenance and responsive adjustments. During the later stage of my work, I independently redesigned and reworked the homepage, including its frontend layout, responsive behavior and JavaScript functionality for dynamically displaying news and announcements. I also carried out a major Joomla upgrade as part of the site's ongoing maintenance.",
    link: "https://onua.edu.ua/ua/",
  },
];

const technologies = [
  "All", "HTML5", "CSS3", "JavaScript (ES6+)", "React.js", "Vue.js", "Node.js & Express.js", "REST API", "Tailwind CSS",
]

const container = document.getElementById("portfolio");
const root = createRoot(container);
root.render(<ProjectList projects={projects} technologies={technologies} />);